import type { AssetLibraryMediaSelection } from './assetLibraryMediaSelection';

export type MascotOpenWithSlot = 'motion' | 'character' | 'background';

export type AssetLibraryOpenWithPrefill =
  | { target: 'comic'; selection: AssetLibraryMediaSelection }
  | {
      target: 'mascot';
      slot: MascotOpenWithSlot;
      selection: AssetLibraryMediaSelection;
    };

const STORAGE_KEY = 'cartwheel:asset-library-open-with';

export function stashAssetLibraryOpenWithPrefill(
  prefill: AssetLibraryOpenWithPrefill,
): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prefill));
}

export function takeAssetLibraryOpenWithPrefill():
  | AssetLibraryOpenWithPrefill
  | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }

  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  sessionStorage.removeItem(STORAGE_KEY);

  try {
    return JSON.parse(raw) as AssetLibraryOpenWithPrefill;
  } catch {
    return null;
  }
}
